(() => {
  const indexes = document.querySelectorAll('[data-trade-page-index]');

  indexes.forEach((index) => {
    const linkRail = index.querySelector('.trade-factory__index-links');
    const links = [...(linkRail?.querySelectorAll('a[href^="#"]') || [])];
    const destinations = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if (!linkRail || destinations.length === 0) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeId = '';
    let animationFrame = 0;

    const revealActiveLink = (link) => {
      if (!mobileQuery.matches || linkRail.scrollWidth <= linkRail.clientWidth) return;
      link.scrollIntoView({
        behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    };

    const setActiveDestination = (destination, reveal = true) => {
      if (!destination || destination.id === activeId) return;
      const hadActiveDestination = activeId !== '';
      activeId = destination.id;

      links.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${activeId}`;
        if (isActive) {
          link.setAttribute('aria-current', 'location');
          if (reveal && hadActiveDestination) revealActiveLink(link);
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const updateIndex = () => {
      animationFrame = 0;
      const marker = Math.min(window.innerHeight * 0.28, 240) + index.offsetHeight;
      let currentDestination = destinations[0];

      destinations.forEach((destination) => {
        if (destination.getBoundingClientRect().top <= marker) currentDestination = destination;
      });

      setActiveDestination(currentDestination);

      const firstTop = destinations[0].getBoundingClientRect().top + window.scrollY;
      const lastDestination = destinations[destinations.length - 1];
      const lastBottom = lastDestination.getBoundingClientRect().bottom + window.scrollY;
      const progressEnd = Math.max(firstTop + 1, lastBottom - window.innerHeight);
      const progress = Math.max(0, Math.min(100, ((window.scrollY - firstTop) / (progressEnd - firstTop)) * 100));
      index.style.setProperty('--trade-page-progress', `${progress.toFixed(2)}%`);
    };

    const requestUpdate = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(updateIndex);
    };

    links.forEach((link) => {
      link.addEventListener('click', () => {
        const destination = document.querySelector(link.getAttribute('href'));
        setActiveDestination(destination);
      });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('hashchange', requestUpdate);
    window.addEventListener('pageshow', requestUpdate);
    requestUpdate();
  });
})();
